import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { FaRegTrashAlt } from "react-icons/fa";

const Delete = ({
  id = "btn-delete",
  title,
  icon = <FaRegTrashAlt />,
  type = "primary",
  danger = true,
  onClick = () => {},
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.delete");

  return (
    <Button
      className={`flex items-center justify-center hover:opacity-70 ${className}`}
      id={id}
      type={type}
      icon={icon}
      onClick={onClick}
      danger={danger}
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

export default memo(Delete);
